import ProjectLayout from "../ProjectLayout";
import "../ProjectPage.css";

export default function NeuroPage() {

  return (
    <ProjectLayout
      title="Neuromersiv"
      role="Unity Developer (C#) - VR (Quest 3 - Hand Tracking)"
      team="2"
      duration="3 Months (Contract)"
      engine="Unity (C#) - VR"
      about="Neuromersiv was a digital health company with the aim to treat chronic brain related health conditions using truly immersive virtual reality (VR). Neuromersiv's Ulysses® is a TGA & UK MHRA registered VR based upper-limb therapy system that empowers stroke, spinal cord and acquired brain injury survivors by helping them regain lost independence and quality of life. Ulysses enhances rehabilitation through clinically validated, task-specific training in immersive VR to maximise engagement, compliance and functional recovery."
      videoSrc={`https://neurogoblin-videos.s3.us-east-2.amazonaws.com/neuro.mp4`}
      playLink={`https://www.linkedin.com/company/neuromersiv`}
      playText={"Neuromersiv LinkedIn"}
      galleryImages = {[
    `${process.env.PUBLIC_URL}/img/neuro/1.gif`,
    `${process.env.PUBLIC_URL}/img/neuro/2.png`,
    `${process.env.PUBLIC_URL}/img/neuro/3.png`,
  ]}
    >
      <section>
        <h2>About</h2>
        <p>
          Neuromersiv was an innovative VR startup that used hand-tracked VR
          experiences to help those with chronic brain conditions such as stroke
          to live a better quality of life through rehabilitative VR training
          programs.
        </p>
      </section>

      <section>
        <h2>What I Learned</h2>
        <p>
          Being a solo developer, Neuromersiv was a great opportunity to develop
          my skills as an independent developer, allowing greater creative
          control and decision making over the technical aspects of the
          platform. It was extremely rewarding to see real stroke patients using
          the platform and noticing their improvements (however slight) in real
          time. Unfortunately, Neuromersiv went out of business in mid 2025.
        </p>
      </section>

    
    </ProjectLayout>
  );
}
